import React from "react";

export function Toolbar({children}) {
  return (
    <div className="toolbar">
      {children}
    </div>
  );
}
